// const environment = {
//   "env": "dev",
//   "enableDebug": true,
//   "siteKey": "6Ldc6tUiAAAAABDHRDlMiqKxs3qm6dkhIH9_LIAM",
//   "apiBaseUrl": "https://d-console.thelightbulb.ai/isp_qual_api/",
//   "secretKey": "73229731d7d042999b43fa6dc8228097",
//   "zoomAuthUrl": "https://zoom.us/oauth/authorize",
//   "googleAuthUrl": "https://accounts.google.com/o/oauth2/auth",
//   "teamsAuthUrl": "https://login.microsoftonline.com/",
//   "showProcessingTypeDropdownToLightbulbOnly": false,
//   "showInsightCube": true
// };

// const baseUrl = environment.apiBaseUrl;
// const zoomAuthUrl = environment.zoomAuthUrl;
// const googleAuthUrl = environment.googleAuthUrl;
// const teamsAuthUrl = environment.teamsAuthUrl;

export const SIGNUP_URL = 'account/sign_up';
export const VERIFY_EMAIL_URL = 'user/verify_email';
export const VERIFY_2FA_URL = 'user/two_fa_login';
export const ADMIN_SIGNIN_URL = 'user/login';
export const RESET_PASSWORD_URL = 'user/reset_password_with_otp';
export const SEND_OTP_URL = 'user/send_otp';
export const GET_USER_PROFILE_URL = 'user/user_profile';
export const PROFILE_IMAGE_URL = 'user/profile_image';
export const MANAGE_2FA_URL = 'user/manage_2fa';
export const PUT_USER_PROFILE_URL = 'user/update_profile';
export const GET_COUNTRIES_URL = 'user/countries';

export const RESET_PASSWORD_WITHOUT_OTP_URL = 'user/reset_password';
export const GET_MEDIA_TOKEN_URL = (fileType: string) =>
  `user/get_media_token?file_extension=${fileType}`;

export const INITIATE_UPLOAD_URL = (fileName: string, fileSize: string) => `user/upload/get_upload_id?file_name=${fileName}&file_size=${fileSize}`;
export const UPLOAD_VIDEO_URL = (uploadId: string, isLastFile: boolean) => `user/upload/upload_file/${uploadId}?completed=${isLastFile}`;

// for videos
export const GET_GDRIVE_THUMBNAIL_URL = (
  projectId: number,
  stimuliId: number,
  filename: string,
  mediaToken: string
) => `project/${projectId}/get_stimuli_media/${stimuliId}/${filename}?t=${mediaToken}`;

export const GET_FRAME_FROM_VIDEO_URL = (
  objId: string, // participantBaseId or meetingId
  second: number,
  mediaToken: string,
  isMeeting: boolean,
  projectId = 0
) => {
  if (isMeeting) {
    return (`project/${projectId}/web_meeting/${objId}/meeting_rec_thumbnail/${second}.jpg?t=${mediaToken}`
    );
  }

  return (`project/get_vid_stimuli_img/${objId}/${second}.jpg?t=${mediaToken}`
  );
};

export const CREATE_PROJECT_URL = 'project/add_update_project';
export const UPDATE_PROJECT_URL = (studyId: number) =>
  `project/${studyId}`;
export const GET_ALL_CATEGORIES_URL = 'project/get_config';
export const GET_ALL_PROJECTS_URL = 'project/get_all';
export const GET_PROJECT_URL = (id: any) => `project/${id}`;
export const DELETE_PROJECT_URL = (id: any) => `project/${id}`;
export const REMOVE_PROJECT_LOGO_URL = (projectId: number) =>
  `project/${projectId}/remove_project_logo`;
export const ADD_UPDATE_PROJECT_DETAILS = (projectId: number) =>
  `project/${projectId}/add_update_project_details`;
export const GET_PROJECT_DETAILS_URL = (projectId: number) =>
  `project/${projectId}/project_details`;

export const GET_QUESTIONS_URL = (projectId: number) =>
  `project/${projectId}/question`;
export const SAVE_QUESTIONS_URL = (projectId: number) =>
  `project/${projectId}/save_questions`;
export const DELETE_QUESTION_URL = (projectId: number, qId: number) =>
  `project/${projectId}/question/${qId}`;
export const DELETE_TOPIC_URL = (projectId: number, topicId: number) => 
  `project/${projectId}/topic/${topicId}`;
export const UPDATE_TOPIC_URL = (projectId: number, topicId: number) => 
  `project/${projectId}/topic/${topicId}`;
export const GET_TOPICS_URL = (projectId: number) => 
  `project/${projectId}/question`;

export const GET_ALL_STIMULI_URL = (projectId: number) =>`project/${projectId}/get_all_project_stimuli?req_page_no=1&page_size=150`;
export const SAVE_STIMULI_URL = (projectId: number) =>
  `project/${projectId}/save_stimuli`;
export const DELETE_STIMULI_URL = (projectId: number, stimuliId: number) =>
  `project/${projectId}/delete_stimuli/${stimuliId}`;
export const PUBLISH_STIMULI_URL = (projectId: number) =>
  `project/${projectId}/publish_stimuli`;
export const UPDATE_STIMULI_SEQUENCE_URL = (projectId: number) =>
  `project/${projectId}/arrange_stimuli_seq`;
export const GET_STIMULI_PARTICIPANTS_URL = (
  projectId: number,
  stimuliId: number
) => `project/${projectId}/get_stimuli_participants/${stimuliId}`;
export const GET_STIMULI_URL = (projectId: number, stimuliId: number) =>
  `project/${projectId}/get_stimuli_by_id/${stimuliId}`;
export const GET_EMOTIONS_URL = (projectId: number, stimuliId: number) =>
  `project/${projectId}/get_stimuli_emotion_report/${stimuliId}`;
export const MERGE_PARTICIPANTS_URL = (projectid: number, stimuliId: number) =>
  `project/${projectid}/multiple_merge_data_by_id/${stimuliId}`;
export const DELETE_PARTICIPANT_URL = (
  projectId: number,
  objId: number, // meeting id or stimuli id
  participantid: string,
  isMeeting: boolean
) =>`project/${projectId}/delete_by_participant_id/${participantid}?${
    isMeeting ? 'web_meeting_id' : 'stimuli_id'
  }=${objId}`;

export const UNDO_PARTICIPANT_MERGE_URL = (
  projectId: number,
  objId: number, 
  participantid: string,
  isMeeting: boolean
) => {
  return (`project/${projectId}/undo_participant_merge/${participantid}?${
      isMeeting ? 'web_meeting_id' : 'stimuli_id'
    }=${objId}`
  );
}

export const GET_ALL_SPEAKERS_URL = (
  projectId: number,
  objId: number,
  isMeeting: boolean
) => {
  const url = `project/${projectId}/get_all_speakers`;
  return url + `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
};

export const TAG_SPEAKER_WITH_PARTICIPANT_URL = (
  projectId: number,
  objId: number,  // meeting id or stimuli id
  speakerId: number,
  participantId: string,
  isMeeting: boolean
) => {
  return (`project/${projectId}/sync_speaker_and_participant/${speakerId}/${participantId}?${
      isMeeting ? 'web_meeting_id' : 'stimuli_id'
    }=${objId}`
  );
}

export const GET_TRANSCRIPT_URL = (
  projectId: number,
  objId: number,
  isMeeting: boolean
) => {
  return (`project/${projectId}/get_project_transcripts?${
      isMeeting ? 'web_meeting_id' : 'stimuli_id'
    }=${objId}`
  );
};
export const GET_ALL_TRANSCRIPT_URL = (projectId: number) =>
  `project/${projectId}/get_project_transcripts`;
export const RENAME_SPEAKER_URL = (projectId: number, stimuliId: number) =>
  `project/${projectId}/stimuli/${stimuliId}/rename_speaker`;

export const GET_WORD_CLOUD_URL = (
  projectId: number,
  objId: number | null,
  isMeeting: boolean
) => {
  const url = `project/${projectId}/get_wordcloud_data`;
  if (objId) {
    return url + `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
  }
  return url;
};
export const UPDATE_WORD_CLOUD_URL = (
  projectId: number,
  objId: number | null,
  isMeeting: boolean
) => {
  const url = `project/${projectId}/save_word_cloud_data`;
  if (objId) {
    return url + `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
  }
  return url;
};
export const SAVE_WORD_CLOUD_COLORS_URL = (
  projectId: number,
  objId: number | null,
  isMeeting: boolean
) => {
  let url = `project/${projectId}/save_word_cloud_data_colours`;
  if (objId) {
    return url + `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
  }
  return url;
};

export const GET_ANSWERS_URL = (
  projectId: number,
  objId: number | null,
  { isMeeting = false }
) => {
  let url = `project/${projectId}/get_speaker_answers`;

  if (objId === null) {
    return url;
  }

  return url + `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
};
export const GET_SESSIONS_URL = (projectId: number) => `project/${projectId}/session/get_sessions_snap_shot`;
export const GET_SESSION_DETAIL_URL = (projectId: number, sessionId: string) =>
  `project/${projectId}/session/${sessionId}/get_session_detail`;
export const ASK_QUESTION_URL = (projectId: number) =>
  `project/${projectId}/session/add_session_question`;
export const UPDATE_SESSION_TITLE_URL = (
  projectId: number,
  sessionId: string
) => `project/${projectId}/session/${sessionId}/update_session_title`;
export const UPDATE_ANSWER_RATING_URL = (
  projectId: number,
  sessionId: string
) => `project/${projectId}/session/${sessionId}/set_answer_rating`;
export const DELETE_SESSION_URL = (
  projectId: number,
  objId: number | undefined, // stimuli_id or web_meeting_id
  sessionId: string,
  isMeeting: boolean
) => {
  let url =
    `project/${projectId}/session/${sessionId}/delete_session`;
  if (objId) {
    url += `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
  }
  return url;
};

// export const GET_USER_MEETING_PLATFORM_STATUS =
//   `user/get_user_meeting_platform_status`;
// export const GET_MEETING_PLATFORM_CREDS =
//   `user/get_meeting_platform_creds`;
// export const SET_USER_MEETING_CREDS = `user/set_user_meeting_creds`;

// export const ZOOM_INTEGRATION = (clientId: string, redirectUrl: string) =>
//   `${zoomAuthUrl}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}`;
// export const GOOGLE_INTEGRATION = (clientId: string, redirectUrl: string) =>
//   `${googleAuthUrl}?client_id=${clientId}&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email https://www.google.com/calendar/feeds&access_type=offline&redirect_uri=${redirectUrl}`;
// export const TEAMS_INTEGRATION = (
//   clientId: string,
//   redirectUrl: string,
//   tenantId: string
// ) =>
//   `${teamsAuthUrl}${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUrl}&scope=${encodeURIComponent(
//     'https://graph.microsoft.com/Calendars.ReadWrite https://graph.microsoft.com/OnlineMeetings.ReadWrite https://graph.microsoft.com/User.Read offline_access'
//   )}`;

// export const SCHEDULE_MEETING = (projectId: number) =>
//   `project/${projectId}/web_meeting/schedule_meeting`;
// export const RESCHEDULE_MEETING = (projectId: number, meetingId: any) =>
//   `project/${projectId}/web_meeting/${meetingId}/reschedule_meeting`;
// export const DELETE_MEETING = (projectId: number, meetingId: any) =>
//   `project/${projectId}/web_meeting/${meetingId}/delete_meeting`;
// export const GET_MEETINGS = (projectId: number) =>
//   `project/${projectId}/web_meeting/get_meetings`;
// export const GET_MEETING_URL = (projectId: number, meetingId: number) =>
//   `project/${projectId}/web_meeting/${meetingId}`;

export const REGENERATE_ANSWER_URL = (
  projectId: number,
  objId: number | undefined, // stimuli_id or web_meeting_id
  sessionId: string,
  qId: any,
  isMeeting: boolean
) => {
  let url = `project/${projectId}/session/${sessionId}/question/${qId}/regenerate_answer`;

  if (objId) {
    return url + `?${isMeeting ? 'web_meeting_id' : 'stimuli_id'}=${objId}`;
  }
  return url;
};

// export const DOWNLOAD_FACIAL_CODING_CSV_URL = (
//   projectId: number,
//   stimuliId: number | null
// ) => {
//   if (stimuliId) {
//     return (
//       baseUrl +
//       `project/${projectId}/stimuli/${stimuliId}/get_tester_emotion_csv_data`
//     );
//   }

//   return `project/${projectId}/get_tester_emotion_csv_data`;
// };

// export const GET_PARTICIPANT_MEETING_DETAILS = (pwd: string) =>
//   `web_meeting/get_participant_meeting_details/${pwd}`;
// export const GET_MEETING_BY_ENC_ID = (encId: string) =>
//   `web_meeting/get_meeting_by_enc_id/${encId}`;
// export const ADD_PARTICIPANT = (encId: string) =>
//   `web_meeting/${encId}/add_participant`;
// export const ADD_LM_PARTICIPANT_IMAGE = (pId: string, mId: string) =>
//   `project/${pId}/web_meeting/${mId}/add_lm_participant_image`;
// export const STOP_MEETING = (pId: string, mId: string) =>
//   `project/${pId}/web_meeting/${mId}/stop_meeting`;

// export const GET_WEB_MEETING_PARTICIPANTS = (pId: number, mId: number) =>
//   `project/${pId}/get_web_meeting_participants/${mId}`;
// export const GET_MEET_PARTI_EMOTION_REPORT = (pId: number, mId: number) =>
//   `project/${pId}/get_meet_parti_emotion_report/${mId}`;
// export const GET_AGGREGATE_EMOTION = (pId: number) =>
//   `project/${pId}/get_aggregated_stimuli_emotion_report`;
// export const START_MEETING = (projectId: number, WebMeetingId: number) =>
//   `project/${projectId}/web_meeting/${WebMeetingId}/start_meeting`;
// export const ADD_ANNOTATION = (projectId: number, id: number, isMeeting: boolean = false) => {
//   let url = `project/${projectId}/add_annotations`;
//   if(isMeeting){
//     url = url+ `?web_meeting_id=${id}`;
//   } else {
//     url = url+`?stimuli_id=${id}`;
//   }
//   return url;
// }
// export const GET_ANNOTATION = (projectId: number, id: number, isMeeting: boolean = false) => {
//   let url = `project/${projectId}/get_annotations`;
//   if(isMeeting){
//     url = url+ `?web_meeting_id=${id}`;
//   } else {
//     url = url+`?stimuli_id=${id}`;
//   }
//   return url;
// }

// export const GET_AGGREGATED_ANNOTATIONS = (projectId: number)=> baseUrl+`project/${projectId}/get_aggregated_annotations`;

// export const GET_QUESTION_ANSWER_URL = (projectId: number, stimuliId: number, questionId: number) => baseUrl+`project/${projectId}/stimuli/${stimuliId}/get_que_answer/${questionId}`;

// export const SAVE_EMOTION_MAPPING = (projectId: number)=> `project/${projectId}/save_emotion_map`;

// // objectives and report builder
// export const GET_OBJECTIVES_URL = (projectId: number) =>
//   `project/${projectId}/get_objective`;

// export const SAVE_OBJECTIVES_URL = (projectId: number) =>
//   `project/${projectId}/save_objective`;

// export const GET_REPORT_BUILDER_URL = (projectId: number) => `project/${projectId}/get_report_builder`;
// export const SAVE_REPORT_BUILDER_URL = (projectId: number) => `project/${projectId}/save_report_builder`;

// export const GET_GEN_AI_REPORT = (projectId: number)=> `project/${projectId}/get_gen_ai_report`;

// export const PUBLISH_PROJECT = (projectId: number) =>
//   `project/${projectId}/publish_project`;

// export const PROCESS_CHANGE = (projectId: number) => 
//   `project/${projectId}/process_changes`;

// export const GET_UNPROCESSED_STIMULI_COUNT = (projectId: number) =>
//   `project/${projectId}/get_unprocessed_stimuli_count`;

export const ACCEPT_TERM_CONDITION = `user/accept_term_condition`;

export const GET_SUBSCRIPTION = `user/get_subscription`;
export const CONTACT_TO_SALES = `user/contact_to_sales`;
export const CONTACT_TO_SALES_UNBLOCK_ASK_ISP = `insights_cube/mail_unblock_ask_isp`;
export const RE_ACCEPT_TERM_AND_CONDITIONS = "user/re_accept_term_condition";
export const PROCESS_GEN_AI_REPORT = (projectId: number)=> `project/${projectId}/process_gen_ai_report`;
export const GET_LLM_QUERY_DETAILS = (projectId: number)=> `project/${projectId}/get_llm_query_details`;
export const CREDIT_REQUEST_EMAIL = (projectId: number)=> `project/${projectId}/ask_isp_credit_req_email`;

// insights qube isp_qual_api/insights_cube/list_directory
export const LIST_DIRECTORY = 'insights_cube/list_directory';
export const ADD_FILE = 'insights_cube/add_file';
export const EMBED_FILE = 'insights_cube/embed_files';
export const INSIGHT_QUBE_SESSIONS_SNAP_SHOT = (directoryId: number) => `insights_cube/get_sessions_snap_shot/${directoryId}`;
export const GET_ASK_INSIGHTS_SESSION_SNAPSHOT = `insights_cube/get_sessions_snap_shot`;
export const INSIGHT_QUBE_ADD_SESSIONS = `insights_cube/add_session_question`;
export const INSIGHT_QUBE_SESSION_DETAIL = (sessionId: string) => `insights_cube/get_session_detail/${sessionId}`;
export const INSIGHT_QUBE_SESSION_TITLE_UPDATE = `insights_cube/update_session_title`;
export const INSIGHT_QUBE_SET_ANSWER_RATING = `insights_cube/set_answer_rating`;
export const INSIGHT_QUBE_DELETE_SESSION = (sessionId: string)=> `insights_cube/delete_session/${sessionId}`;
export const INSIGHT_QUBE_REGENERATE_ANSWER = `insights_cube/regenerate_answer`;
export const INSIGHT_FILE_DIR_DELETE = (id:number)=> `insights_cube/delete_file/${id}`;
export const INSIGHT_FILE_DIR_NAME = (id: number)=> `insights_cube/rename_file/${id}`;
export const INSIGHT_GET_STORAGE = `insights_cube/get_storage_usage`;
export const ADD_PPT_JOB = (projectId: number) => `project/${projectId}/add_ppt_job`;
export const GET_REPORT_JOBS = `project/get_report_jobs`;
export const GET_PPT_CONTENT = (projectId: number) => `project/${projectId}/get_ppt_content`;
export const GENERATE_PPT_CONTENT = (projectId: number) => `project/${projectId}/generate_ppt_content`;
export const UPDATE_PPT_CONTENT = (projectId: number) => `project/${projectId}/update_ppt_content`;

// SCOPE
export const SAVE_SCOPE = `insights_cube/search_scope_info`;
export const GET_SAVED_SCOPE = `insights_cube/search_scope_info`;
export const DELETE_SAVED_SCOPE = (scopeId: string) => `insights_cube/search_scope_info/${scopeId}`





